import { Alert } from 'antd'
import React from 'react'

export default function FormAlert({ text, className }: any) {
   if (!text) {
      return null
   }
   return <Alert message={text} className={className} type="error" />
}
